<div class="d-flex flex-row justify-content-center align-items-center w-100 h-100">
  <div class="form-container bg-white shadow-lg d-flex justify-content-between flex-column p-4">
    <img src="../../../../assets/images/AndDoneLogo.png" alt="AndDone Logo" class="loginLogo" />
    <h3 class="text-uppercase fw-semibold my-3">
      {{ 'login.login' | translate }}
    </h3>
    @if (!showGuestUserErrorMessage() && !showEmulationOriginErrorMessage()) {
      <h4>
        {{ 'login.emulateSuccess' | translate }}
      </h4>
    }
    @if (showEmulationOriginErrorMessage()) {
      <h4>
        {{ 'login.emulateServerError' | translate }}
      </h4>
    }
    @if (showGuestUserErrorMessage()) {
      <h4>
        {{ 'login.emulateError' | translate }}
      </h4>
    }
  </div>
</div>
